import React from 'react';
import RecipeModal from './RecipeModal';
import RecipeInsightModal from './RecipeInsightModal';
import RecipeInsightModalSmart from './RecipeInsightModalSmart';
import { RECIPE_INSIGHT_MODAL_V1 } from '../config';

export default function RecipeModalGateway(props) {
  const variant = String(props?.modalVariant || '').toLowerCase();
  if (variant === 'smart') {
    return <RecipeInsightModalSmart {...props} />;
  }
  if (RECIPE_INSIGHT_MODAL_V1) {
    if (variant === 'landing') {
      return <RecipeInsightModal {...props} />;
    }
    return <RecipeInsightModalSmart {...props} />;
  }
  if (variant === 'landing') {
    return <RecipeInsightModal {...props} />;
  }
  return <RecipeModal {...props} />;
}
